import api from './api';

export interface NotificationLog {
  id: number;
  tipo: string;
  origem: 'cron' | 'manual';
  despesas_count: number;
  numero_destino: string | null;
  sucesso: 0 | 1;
  http_code: number | null;
  erro: string | null;
  mensagem_preview: string | null;
  created_at: string;
}

export interface RunDailyResult {
  sucesso: boolean;
  sent: boolean;
  reason?: 'nada_para_enviar' | 'numero_nao_configurado' | 'whatsapp_desconectado';
  despesas_count?: number;
  http_code?: number;
  erro?: string | null;
  mensagem_preview?: string;
  log_id?: number | null;
}

export const notificationsService = {
  /** Dispara manualmente o lembrete diário (mesma lógica do cron). */
  runDaily: async (): Promise<RunDailyResult> => {
    const response = await api.post('/notifications/run-daily');
    return response.data;
  },

  /** Retorna os últimos envios para auditoria. */
  getLogs: async (limit = 20): Promise<NotificationLog[]> => {
    const response = await api.get('/notifications/logs', { params: { limit } });
    return response.data?.logs ?? [];
  },
};
